import { JobListExcelState, JobListExcelActionTypes, DOWNLOAD_JOB_LIST_EXCEL_REQUEST, DOWNLOAD_JOB_LIST_EXCEL_SUCCESS, DOWNLOAD_JOB_LIST_EXCEL_FAILURE } from "store/reducers/types/jobList/jobListExcel";

const defaultState: JobListExcelState = {
  isLoading: false,
  errorMessage: ""
};

export default function jobsExcel(state = defaultState, action: JobListExcelActionTypes): JobListExcelState {
  switch (action.type) {
    case DOWNLOAD_JOB_LIST_EXCEL_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case DOWNLOAD_JOB_LIST_EXCEL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case DOWNLOAD_JOB_LIST_EXCEL_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};